


















import { Component, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ProvidedModalParam } from './types';

@Component({
})
export default class SwModalBody extends SwExtendedVue {
  @Inject()
  modalParam: ProvidedModalParam;
}
